mutation UpdateImpactRecord(
  $impactRecordId: ID!
  $impactRecordInput: ImpactRecordInput!
) {
  updateImpactRecord(
    input: {
      impactRecordId: $impactRecordId
      impactRecordInput: $impactRecordInput
    }
  ) {
    impactRecord {
      id
    }
  }
}
